/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { PIPRedirector }
from '@thd-nucleus/app-render';

import { ProductMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { DynamicRecsWrapperPip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { PIPProductDetails }
from '@thd-olt-component-react/product-details';

import { MediaGalleryWithHotspotsCarousel }
from '@thd-olt-component-react/media-gallery';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { Avataar, RoomVo, RoomVoInspire }
from '@thd-olt-component-react/augmented-reality';

import { ProductPageEventCountdownTimer }
from '@thd-olt-component-react/event-countdown-timer';

import { PIPPriceClearanceWrapper }
from '@thd-olt-component-react/price';

import { Promotion }
from '@thd-olt-component-react/promotion';

import { PromotionProductsAnchor }
from '@thd-olt-component-react/promotion-products';

import { MeasurementGuideMobile }
from '@thd-olt-component-react/measurement-guide';

import { BuyboxWithPIPCalculator }
from '@thd-olt-component-react/buybox';

import { BundlePmvFbtLayoutGmAndHdh }
from '@thd-olt-component-react/bundle-mini';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { ProductOverviewAccordionTitle }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { BazaarVoiceCarousel }
from '@thd-olt-component-react/social-media-container';

import { SponsoredPipBanner }
from '@thd-olt-component-react/sponsored-content';

import { EducationalSummary }
from '@thd-olt-component-react/educational-summary';

import { RetailMediaCarouselFusionPIP }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { TextAnExpert }
from '@thd-olt-component-react/text-an-expert';

import { HdhomeSignup }
from '@thd-olt-component-react/email-signup';

import { RelatedSearch, PopularVariations }
from '@thd-olt-component-react/related-search';

import { EmtLinks }
from '@thd-olt-component-react/emt-links';

export { PIPRedirector };

export { ProductMetadata };

export { Breadcrumbs };

export { DynamicRecsWrapperPip };

export { Discontinued };

export { PIPProductDetails };

export { MediaGalleryWithHotspotsCarousel };

export { PIPSharebelt };

export { Avataar };

export { RoomVo };

export { ProductPageEventCountdownTimer };

export { PIPPriceClearanceWrapper };

export { Promotion };

export { PromotionProductsAnchor };

export { MeasurementGuideMobile };

export { BuyboxWithPIPCalculator };

export { BundlePmvFbtLayoutGmAndHdh };

export { ProductInfoBar };

export { ProductOverviewAccordionTitle };

export { SpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { BazaarVoiceCarousel };

export { RoomVoInspire };

export { SponsoredPipBanner };

export { EducationalSummary };

export { RetailMediaCarouselFusionPIP };

export { RecentlyViewedWrapper };

export { TextAnExpert };

export { HdhomeSignup };

export { RelatedSearch };

export { PopularVariations };

export { EmtLinks };

const SlotA1 = withLayout(
  [

    PIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    ProductMetadata,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC2 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotC3 = withLayout(
  [

    Discontinued,

  ],

);

const SlotD1 = withLayout(
  [

    PIPProductDetails,

  ],

);

const SlotD2 = withLayout(
  [

    MediaGalleryWithHotspotsCarousel,

  ],

);

const SlotD3 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotD4 = withLayout(
  [

    Avataar,

  ],

);

const SlotD5 = withLayout(
  [

    RoomVo,

  ],

);

const SlotE1 = withLayout(
  [

    ProductPageEventCountdownTimer,

  ],

);

const SlotE2 = withLayout(
  [

    PIPPriceClearanceWrapper,

  ],

);

const SlotE3 = withLayout(
  [

    Promotion,

  ],

);

const SlotE5 = withLayout(
  [

    PromotionProductsAnchor,

  ],

);

const SlotE6 = withLayout(
  [

    MeasurementGuideMobile,

  ],

);

const SlotE11 = withLayout(
  [

    BuyboxWithPIPCalculator,

  ],

);

const SlotF1 = withLayout(
  [

    BundlePmvFbtLayoutGmAndHdh,

  ],

);

const SlotF2 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF3 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotF4 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF8 = withLayout(
  [

    BazaarVoiceCarousel,

  ],

);

const SlotF9 = withLayout(
  [

    RoomVoInspire,

  ],

);

const SlotF10 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF11 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF12 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF13 = withLayout(
  [

    SponsoredPipBanner,

  ],

);

const SlotF14 = withLayout(
  [

    EducationalSummary,

  ],

);

const SlotF15 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF16 = withLayout(
  [

    RetailMediaCarouselFusionPIP,

  ],

);

const SlotF17 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF18 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF19 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF20 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF21 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotF22 = withLayout(
  [

    TextAnExpert,

  ],

);

const SlotF23 = withLayout(
  [

    HdhomeSignup,

  ],

);

const SlotF24 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotF25 = withLayout(
  [

    PopularVariations,

  ],

);

const SlotF26 = withLayout(
  [

    EmtLinks,

  ],

);

const ssr = typeof window === 'undefined';

const SlotD6Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
    .AugmentedReality
  : {};

const SlotE4Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
    .ConsumerCardMessaging
  : {};

const SlotE7Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay'))
    .AisleBay
  : {};

const SlotE8Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku'))
    .SuperSku
  : {};

const SlotE9Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample'))
    .OrderSample
  : {};

const SlotE10Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
    .GlobalCustomConfigurator
  : {};

const SlotE12Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging'))
    .ReturnsMessaging
  : {};

const SlotF5Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

const SlotF6Index0DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionTitle
  : {};

const SlotF6Index0DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : {};

const SlotF6Index1DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionTitle
  : {};

const SlotF6Index1DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsWithKPFAccordionBody
  : {};

const SlotF6Index2DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionTitle
  : {};

const SlotF6Index2DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : {};

const SlotF6Index3DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionTitle
  : {};

const SlotF6Index3DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : {};

const SlotF7Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotC1,

  SlotC2,

  SlotC3,

  SlotD1,

  SlotD2,

  SlotD3,

  SlotD4,

  SlotD5,

  SlotE1,

  SlotE2,

  SlotE3,

  SlotE5,

  SlotE6,

  SlotE11,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotF4,

  SlotF8,

  SlotF9,

  SlotF10,

  SlotF11,

  SlotF12,

  SlotF13,

  SlotF14,

  SlotF15,

  SlotF16,

  SlotF17,

  SlotF18,

  SlotF19,

  SlotF20,

  SlotF21,

  SlotF22,

  SlotF23,

  SlotF24,

  SlotF25,

  SlotF26,

  SlotD6Index0DataModel,

  SlotE4Index0DataModel,

  SlotE7Index0DataModel,

  SlotE8Index0DataModel,

  SlotE9Index0DataModel,

  SlotE10Index0DataModel,

  SlotE12Index0DataModel,

  SlotF5Index0DataModel,

  SlotF6Index0DataModelK0,

  SlotF6Index0DataModelBodyK0,

  SlotF6Index1DataModelK0,

  SlotF6Index1DataModelBodyK0,

  SlotF6Index2DataModelK0,

  SlotF6Index2DataModelBodyK0,

  SlotF6Index3DataModelK0,

  SlotF6Index3DataModelBodyK0,

  SlotF7Index0DataModel,

};
